var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D2853",
    fillRule: "evenodd",
    d: "M7.077 0h6.709v3h7.075v1.645h-2.044l-.824 15.414H2.868L2.045 4.645H0V3h7.077V0Zm1.647 3h3.414V1.644H8.724v1.358Zm-5.03 1.645.735 13.77h12.003l.735-13.77H3.695ZM6.42 16.22v-9h1.605v9H6.419Zm3.21 0v-9h1.604v9H9.628Zm3.209 0v-9h1.604v9h-1.604Z"
  })));
};
export default SvgDeleteIcon;